import { useTranslation } from 'react-i18next'
import * as journeySteps from '../steps/index'
import { createComparator } from '../../../utils'
import clsx from 'clsx'
import { DATA_FORMAT } from './JourneyEditorUtils'

export const JourneyComponentDrawer = () => {
    const { t } = useTranslation()
    return (
        <div className="journey-options">
            <h4>{t('components')}</h4>
            <div className="journey-components">
                {
                    Object.entries(journeySteps).sort(createComparator(x => x[1].category)).map(([key, type]) => (
                        <div
                            key={key}
                            className={clsx('component', type.category)}
                            draggable
                            onDragStart={event => {
                                const rect = (event.target as HTMLDivElement).getBoundingClientRect()
                                event.dataTransfer.setData(DATA_FORMAT, JSON.stringify({
                                    type: key,
                                    x: event.clientX - rect.left,
                                    y: event.clientY - rect.top,
                                }))
                                event.dataTransfer.effectAllowed = 'move'
                            }}
                        >
                            <span className={clsx('component-handle', type.category)}>
                                {type.icon}
                            </span>
                            <div className="component-title">{t(type.name)}</div>
                            <div className="component-desc">{t(type.description)}</div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
